import axios from "../utils/axios";

export const getPersonnelSummary = (data) => {
    return axios.post("/User/GetUserTaskStatistics", data);
};

export const getList = () => {
    return axios.get("/Pool/GetList");
};


